<ng-container *ngIf='modalService.state$ | async as template'>
  <div class='app-modal-dialog app-modal-backdrop'>
    <div class='app-modal-content'>
      <header class='app-modal-header'>
        <p>{{ modalService.title | translate }}</p>
        <mat-icon svgIcon="close"
                  class='mat-icon-20'
                  (click)='modalService.close()'
                  (keydown)='modalService.close($event)'>
        </mat-icon>
      </header>
      <div class='app-modal-body'>
        <ng-container *ngTemplateOutlet='template'></ng-container>
      </div>
    </div>
  </div>
</ng-container>
